'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Cloud';

var EntypoCloud = function EntypoCloud(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M20,11.32c0,2.584-2.144,4.68-4.787,4.68H3.617C1.619,16,0,14.416,0,12.463c0-1.951,1.619-3.535,3.617-3.535c0.146,0,0.288,0.012,0.429,0.027C4.009,8.709,3.989,8.457,3.989,8.199C3.989,5.328,6.37,3,9.309,3c2.407,0,4.439,1.562,5.096,3.707c0.263-0.043,0.532-0.066,0.809-0.066C17.856,6.641,20,8.734,20,11.32z' })
    );
};

exports.default = EntypoCloud;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Cloud.js
// module id = 515
// module chunks = 168707334958949